import { render } from "./sendRequest.vue?vue&type=template&id=242317c6"
import script from "./sendRequest.vue?vue&type=script&lang=js"
export * from "./sendRequest.vue?vue&type=script&lang=js"
script.render = render

export default script